import { message } from 'antd';
import { PickupDataResponse } from '@/types';
import { formatSlotWindow12 } from '@/utils/helpers';

// v2-task-12fix (H2) — extracted from useSubmitSingleOrder.tsx (T9) into a
// SHARED module so every "ship" call site that hits the SINGLE-pickup
// endpoint (POST /merchants/pick-ups/request — the one that synchronously
// returns the stamped pick-up, via `dispatch_now(new RequestJob(...))` +
// PickUp::getSlotAttribute()) can surface the same silent-auto-advance
// toast, instead of this logic living only on the order-details page.
//
// Only the FIRST pick-up in the response is relevant — every caller of this
// helper ships exactly one pick-up per call (a single order, or a single
// row's "Ship Now"). A merge-joined advance always has `auto_advanced:
// false` (per the T3 roll-up) — deliberately NOT toasted, so this only
// fires on a genuine silent re-slot.
//
// Do NOT wire this into a bulk/fire-and-forget ship endpoint (e.g.
// POST /merchants/pick-ups/bulk-request, dispatched as an async Job with no
// stamped pick-up in the response body) — `response?.object` will always be
// empty there, so the call would be permanently dead code. See
// useSubmitOrders.tsx's comment for why that hook is deliberately NOT wired.
export type ToastTranslateFn = (key: string, opts?: Record<string, unknown>) => unknown;

export const showAutoAdvanceToastIfAny = (
  response: PickupDataResponse | undefined,
  t: ToastTranslateFn,
) => {
  const advanced = response?.object?.[0];
  if (!advanced?.auto_advanced || !advanced.slot) return;

  message.success(
    String(
      t('auto_advance_toast', {
        window: formatSlotWindow12(advanced.slot.window_from, advanced.slot.window_to),
      }),
    ),
  );
};
